export const environment = {
  production: true,
  name: "staging",
  drupalUsername: "",
	location: "TBD",
  drupalPassword: "",
  drupalUrl: 'https://app.staging.letsdance.tech',
  hostUrl: 'https://app.staging.letsdance.tech',
  subFolder: '/app/',
  logRocketKey: 'i7mbrj/agendamaster-stagingaaa',
  stripePublicKey: '',
  stripePublicKeyFetchUrl: '/api/stripe-public-key',
  // Subscription and payment redirect URLs
  successRedirectUrl: 'https://app.staging.letsdance.tech/subscription/confirmation?session_id={CHECKOUT_SESSION_ID}',
  cancelRedirectUrl: 'https://app.staging.letsdance.tech/subscription/canceled'
};
